import store from '../store'

export function checkPermission(requiredPermission) {
    const { auth } = store.getState()
    const permissions = auth.user.role_permissions
    return permissions[requiredPermission] || false
}
